var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "400" },
      model: {
        value: _vm.opened,
        callback: function($$v) {
          _vm.opened = $$v
        },
        expression: "opened"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-row",
            {
              staticClass:
                "modal-title white--text d-flex align-center px-2 py-4",
              attrs: { "no-gutters": "" }
            },
            [
              _c("v-col", { attrs: { cols: "11" } }, [
                _c(
                  "h3",
                  { staticClass: "d-flex align-center font-weight-regular" },
                  [
                    _c("v-icon", { staticClass: "mr-2", attrs: { dark: "" } }, [
                      _vm._v("mdi-power")
                    ]),
                    _vm._v(" Confirmación de cierre de sesión ")
                  ],
                  1
                )
              ]),
              _c(
                "v-col",
                {
                  staticClass: "d-flex flex-row-reverse",
                  attrs: { cols: "1" }
                },
                [
                  _c(
                    "v-icon",
                    {
                      attrs: { dark: "" },
                      on: {
                        click: function() {
                          return _vm.closeModal()
                        }
                      }
                    },
                    [_vm._v("mdi-close")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            [
              _c("div", { staticClass: "logout-question px-4 py-6" }, [
                _vm._v("¿Está seguro de cerrar sesión?")
              ]),
              _c(
                "v-row",
                { attrs: { "no-gutters": "" } },
                [
                  _c(
                    "v-col",
                    { staticClass: "mr-1" },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { block: "", outlined: "", color: "green" },
                          on: {
                            click: function() {
                              return _vm.closeModal()
                            }
                          }
                        },
                        [_vm._v("CANCELAR")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "ml-1" },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { block: "", color: "green", dark: "" },
                          on: {
                            click: function() {
                              return _vm.logout()
                            }
                          }
                        },
                        [_vm._v("ACEPTAR")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }